import { segunTienda } from './tienda';

// Traduce errores técnicos (Supabase, red) a mensajes amigables en español.
export function mensajeAmigable(error) {
  // Errores de validación de datos: ya vienen escritos para la persona
  // (ej. "El monto tiene que ser un número"). Se muestran tal cual.
  if (error?.code === 'DATO_INVALIDO' && error.message) return error.message;

  const msg = (error?.message || '').toLowerCase();
  if (msg.includes('failed to fetch') || msg.includes('network'))
    return 'Sin conexión a internet. Revisa tu conexión e intenta de nuevo.';
  if (msg.includes('timeout'))
    return 'La operación tardó demasiado. Intenta de nuevo.';
  if (msg.includes('duplicate'))
    return 'Ya existe un registro con esos datos.';
  if (msg.includes('jwt') || msg.includes('unauthorized') || msg.includes('invalid api key'))
    return 'Problema de acceso a la base de datos. Contacta a soporte.';
  if (msg.includes('cuenta_pausada'))
    return segunTienda('Tu cuenta está pausada: puedes ver tus datos, pero no guardar cambios. Ve a "Mi plan" para reactivarla.', 'Tu cuenta está pausada: puedes ver tus datos, pero no guardar cambios.');
  if (msg.includes('venta_facturada'))
    return 'Esta venta ya tiene factura emitida: no se puede borrar ni cambiar. Primero anula la factura en 🏛️ Facturas.';
  if (msg.includes('solo_duena'))
    return 'Solo la dueña del negocio puede hacer esto. Pídele que lo haga desde su cuenta.';
  if (msg.includes('demasiados_pedidos'))
    return 'Esta tienda está recibiendo muchos pedidos en este momento. Intenta de nuevo en unos minutos o escríbele por WhatsApp.';
  if (msg.includes('payload too large') || msg.includes('too large'))
    return 'El archivo es demasiado grande. Intenta con una foto más liviana.';
  return 'Algo salió mal. Intenta de nuevo en unos segundos.';
}
